(function () {
  /* ============================================================
     SHARED INVENTORY — single source of truth.
     These now come from window.WRX_INVENTORY / WRX_PANEL_INVENTORY,
     set by an inline <script> in the page template from live Shopify
     data (see page.werecover-masterclass-preorder.liquid). All three
     kits read this ONE number. When it hits 0, the entire section
     flips to sold out. Shopify side: enable "Continue selling when
     out of stock" on Complete/Ultimate variants; cap their sellable
     count at the Essentials component stock (see handoff notes).
     ============================================================ */
  var root = document.getElementById('wrx');
  var WRX_INVENTORY = parseInt(root.dataset.wrxInventory, 10) || 0;
  var WRX_INVENTORY_TOTAL = parseInt(root.dataset.wrxInventoryTotal, 10) || 200;
  var WRX_PANEL_INVENTORY = parseInt(root.dataset.wrxPanelInventory, 10) || 0;

  if (WRX_INVENTORY <= 0) {
    root.classList.add('wrx-soldout');
    root.querySelectorAll('.wrx-cta[data-wrx-kit]').forEach(function (btn) {
      btn.disabled = true;
      btn.textContent = 'Sold Out';
    });
    root.querySelectorAll('.wrx-prestrip').forEach(function (r) { r.textContent = 'Sold Out'; });
    root.querySelectorAll('.wrx-inv strong').forEach(function (s) { s.textContent = 'Sold out'; });
  }

  /* ---------------- Pre-order modal ---------------- */
  var overlay = document.getElementById('wrxModalOverlay');
  var checkbox = document.getElementById('wrxTermsCheck');
  var goBtn = document.getElementById('wrxModalGo');
  var backBtn = document.getElementById('wrxModalBack');
  var pendingCheckoutUrl = null;
  var lastFocused = null;

  var panelInStock = WRX_PANEL_INVENTORY > 0;

  var KIT_ITEMS = {
    complete: 'the WeRelieve Red Light Belt',
    ultimate: panelInStock ? 'the WeRelieve Red Light Belt' : 'the WeRelieve Red Light Belt and the WeRestore Panel + Stand'
  };
  var KIT_ITEMS_SHORT = {
    complete: 'belt',
    ultimate: panelInStock ? 'belt' : 'belt, panel, and stand'
  };

  /* ---- Ultimate panel: in-stock vs pre-order state ---- */
  if (panelInStock) {
    var panelItem = document.getElementById('wrxPanelItem');
    panelItem.classList.remove('wrx-item--pre');
    panelItem.classList.add('wrx-item--panelstock');
    document.getElementById('wrxPanelPill').outerHTML =
      '<span class="wrx-panel-left">In stock · Only ' + WRX_PANEL_INVENTORY + ' left · Ships right away</span>';
    document.getElementById('wrxUltStrip').textContent = 'Only ' + WRX_PANEL_INVENTORY + ' Panels Left · Belt on Pre-Order';
    document.getElementById('wrxUltShipNote').innerHTML =
      '<strong>Roller, gun, ball, panel &amp; stand ship right away.</strong><br>Your belt follows in its own shipment.';
    document.getElementById('wrxStandNote').textContent = '(ships now with your panel)';
  }

  function openModal(kit, checkoutUrl) {
    pendingCheckoutUrl = checkoutUrl;
    document.querySelector('[data-wrx-modal-items]').textContent = KIT_ITEMS[kit];
    document.querySelector('[data-wrx-modal-items2]').textContent = KIT_ITEMS_SHORT[kit];
    document.querySelector('[data-wrx-modal-items3]').textContent = KIT_ITEMS[kit];
    checkbox.checked = false;
    goBtn.disabled = true;
    goBtn.classList.remove('wrx-cta--red');
    if (kit === 'ultimate') goBtn.classList.add('wrx-cta--red');
    lastFocused = document.activeElement;
    overlay.classList.add('wrx-open');
    checkbox.focus();
  }

  function closeModal() {
    overlay.classList.remove('wrx-open');
    pendingCheckoutUrl = null;
    if (lastFocused) lastFocused.focus();
  }

  root.querySelectorAll('.wrx-cta[data-wrx-kit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var kit = btn.getAttribute('data-wrx-kit');
      var url = btn.getAttribute('data-wrx-checkout');
      if (kit === 'essentials') {
        window.location.href = url; /* in stock — straight to checkout */
      } else {
        openModal(kit, url);
      }
    });
  });

  checkbox.addEventListener('change', function () { goBtn.disabled = !checkbox.checked; });
  goBtn.addEventListener('click', function () { if (checkbox.checked && pendingCheckoutUrl) window.location.href = pendingCheckoutUrl; });
  backBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('wrx-open')) closeModal(); });
})();
